import React from "react";
import { Card, Typography, Avatar, Tag, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { TableComponent } from "../../global/TableComponent";
import { ProvidersData } from "../../../helpers/interfaces/ProvidersInterfaces";
import { ProviderExpandedRowComponent } from "./ProviderExpandedRowComponent";

const { Text } = Typography;

const getInitials = (name: string = "") => {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

const columns: ColumnsType<ProvidersData> = [
   {
    title: "PROVIDER ID",
    dataIndex: "provider_id",
    key: "provider_id",
    width: 150,
    render: (id) => <Text strong style={{ color: "#2E314D" }}>{id}</Text>,
  },
  {
    title: "PROVIDER NAME",
    dataIndex: "provider_name",
    key: "provider_name",
    render: (text, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <Avatar 
          shape="square" 
          size={40} 
          style={{ 
            backgroundColor: "#f1f5f9", 
            color: "#1e293b", 
            fontWeight: 700,
            fontSize: "14px",
            borderRadius: "8px",
            border: "1px solid #eef0f2"
          }}
        >
          {getInitials(record.provider_name)}
        </Avatar>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text strong style={{ margin: 0, color: "#1e293b", fontSize: "14px" }}>{record.provider_name}</Text>
          <Text type="secondary" style={{ fontSize: "11px" }}>
            {record.provider_type?.provider_type_name || "Finance Provider"}
          </Text>
        </div>
      </div>
    ),
  },
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    width: 150,
    render: () => (
      <Tag color="success" style={{ borderRadius: "12px", border: "none", background: "#f0fdf4", color: "#22c55e" }}>
        LIVE
      </Tag>
    ),
  },
  {
    title: "CREATED DATE",
    dataIndex: "created_at",
    key: "created_at",
    width: 200,
    render: (date) => (
      <Text strong style={{ color: "#2E314D" }}>
        {new Date(date).toLocaleDateString()}
      </Text>
    ),
  },
  {
    title: "LAST MODIFIED DATE",
    dataIndex: "updated_at",
    key: "updated_at",
    width: 200,
    render: (date) => (
      <Text strong style={{ color: "#2E314D" }}>
        {new Date(date).toLocaleDateString()}
      </Text>
    ),
  },
 
];

export const ProviderTableComponent = ({
    tableProps,
    onPaginationChange,
    onSelectRow,
    selectedRowKey,
}: any) => {

  const meta = tableProps?.data?.meta;
  const data = tableProps?.data?.data;

  if (!meta && !data) {
    return (
      <Card bordered={false} style={{ marginTop: "24px", textAlign: "center", borderRadius: "12px" }}>
        <Text type="secondary">No providers found matching your criteria.</Text>
      </Card>
    );
  }

  const expandedRowRender = (record: ProvidersData) => (
    <ProviderExpandedRowComponent record={record} />
  );

  return (
    <div style={{ marginTop: "2%" }}>
      <TableComponent
        columns={columns}
        data={data}
        pagination={
          meta
            ? { 
                current: meta.current_page,
                pageSize: meta.per_page,
                total: meta.total,
                onChange: onPaginationChange,
                showSizeChanger: false
              }
            : {}
        }
        onSelectRow={onSelectRow}
        selectedRowKey={selectedRowKey}
        selectionType="radio"
        expandable={{
          expandedRowRender,
          rowExpandable: (record: ProvidersData) =>
            !!record.monthly_terms?.length || !!record.calculation_settings?.length,
        }}
      />
      <style>{`
        .ant-table-thead > tr > th {
          background: #f8f9fb !important;
          color: #64748b !important;
          font-size: 11px !important;
          letter-spacing: 1px !important;
          font-weight: 600 !important;
          border-bottom: 1px solid #eef0f2 !important;
        }
        .ant-table-row:hover > td {
          background: #fbfcfd !important;
        }
        .ant-table-cell {
          padding: 16px 24px !important;
        }
      `}</style>
    </div>
  );
};
